document.addEventListener('DOMContentLoaded', () => {
	const storeNewsletters = [
		document.querySelector('.section-newsletter__form'), // section-newsletter
		document.querySelector('.newsletter-modal__form'), // Popup
		document.querySelector('.footer__newsletter-form'), // Footer
	];

	storeNewsletters.forEach((newsletter) => {
		if (newsletter) {
			setNewsletterTermsValidationMessage(newsletter);
		}
	});
});

function setNewsletterTermsValidationMessage(newsletter) {
	const acceptTermsCheckbox = newsletter.querySelector('.newsletter-accept-terms-input');

	newsletter.addEventListener('change', () => {
		if (acceptTermsCheckbox?.checked) {
			// You must clear the validity message in order to submit
			acceptTermsCheckbox?.setCustomValidity('');
		}
	});

	// Set validation message if checkbox is not checked
	acceptTermsCheckbox?.addEventListener('invalid', () => {
		acceptTermsCheckbox?.setCustomValidity(
			// eslint-disable-next-line quotes
			"You must accept the terms and conditions before subscribing"
		);
	});
}
